import window from 'window-or-global';

import { DEV } from '../globals';

export enum MicrosEnv {
	ADEV = 'adev',
	STG_EAST = 'stg-east',
	PROD_EAST = 'prod-east',
}

export const envMap: {
    local: string;
    test: string;
    prod: string;
    stg: string;
    adev: string;
    "stg-east": string;
    "prod-east": string;
} = {
	local: 'local',
	test: 'test',
	prod: 'prod',
	stg: 'staging',
	[MicrosEnv.ADEV]: 'staging',
	[MicrosEnv.STG_EAST]: 'staging',
	[MicrosEnv.PROD_EAST]: 'production',
};

type SimpleEnv = 'prod' | 'stg';
type ComplexEnv = 'prod-east' | 'stg-east';

const SIMPLE_TO_DAMN_COMPLEX_ENV: Record<SimpleEnv, ComplexEnv> = {
	prod: 'prod-east',
	stg: 'stg-east',
};

let presetEnv: ComplexEnv;
export const setEnv = (env: SimpleEnv): void => {
	const envOverride = SIMPLE_TO_DAMN_COMPLEX_ENV[env];
	if (envOverride) {
		presetEnv = envOverride;
	}
};

/**
 * The region specified here is not the correct region for the environment.
 * It's always stg-east/prod-east for staging/production.
 * The environment is set by `setEnv` which is called by products(Jira/Confluence and etc.),
 * but products don't always set the correct region
 * If the environment is not preset by products, it will get it from window.__env__.
 */
export function getEnv(): MicrosEnv | 'local' {
	if (presetEnv) {
		return presetEnv as MicrosEnv;
	}

	if (DEV) {
		return 'local';
	}

	// @ts-ignore
	return window.__env__ as MicrosEnv;
}

export function getMappedEnv(): string {
	return envMap[getEnv()];
}
